<template>
    <div>
        <div class="modal" id="modalConfirmar" data-backdrop="false" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <span class="asdjhsa">Advertencia</span>
                        <button type="button" class="close" @click="handleClose" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <span>¿Al cambiar respuesta del alumno afectará a la nota de la evaluacion, desea continuar?</span>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" @click="handleOk">Si</button>
                        <button type="button" class="btn btn-danger" @click="handleClose">No</button>
                        <button type="button" ref="CloseModalShowEvaluacionConfirmar" class="btn btn-danger" hidden="hidden" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from "jquery";
    export default({
        methods:{
           handleOk(){
               this.$emit('clicked', true);
               this.$refs.CloseModalShowEvaluacionConfirmar.click();
           },
           handleClose(){
               this.$emit('clicked', false);
               this.$refs.CloseModalShowEvaluacionConfirmar.click();
           }
        },
        created(){
            $(document).ready(function(){
                $('#modalConfirmar').modal('show');
            });
        }
    })
</script>

<style scoped>
  .modal {
    background-color: rgba(0, 0, 0, 0.712)
  }
  .modal-content {
      margin-top: 120px;
  }
  .asdjhsa{
    font-weight: bolder;
    font-size: x-large;
    font-style: italic;
  }
  .btn-light{
    border: 1px solid gray;
  }
</style>